import { lazyLoad } from 'utils/loadable';

export const MedicalPage = lazyLoad(
  () => import('./index'),
  module => module.MedicalPage,
);
